<div class="store-icons flex items-center">
  <a [routerLink]="path" class="l">
    <div *ngIf="isMobile">
      <div *ngIf="smallLogo">
        <div style="width: auto;">
          <img
            [src]="smallLogo | assetPreview:'small':'webp'"
            [alt]="smallLogo?.customFields?.altText || 'logo'"
            [style.height]="logoHeight"
            [attr.height]="logoHeight"
            [attr.width]="getDisplayWidthPx(smallLogo, logoHeight)"
            class="block w-auto object-contain"
            decoding="async" />
        </div>
      </div>
    </div>
    <div *ngIf="(isMobile===false)" class="hover:scale-110 transition duration-300 ease-in-out">
      <ng-container *ngIf="nameLogo; else squareLogo">
        <div style="width: auto;">
          <img
            [src]="nameLogo | assetPreview:'small':'webp'"
            [alt]="nameLogo?.customFields?.altText || 'logo'"
            [style.height.px]="NAMELOGO_HEIGHT_PX"
            [attr.height]="NAMELOGO_HEIGHT_PX"
            [attr.width]="getDisplayWidthPx(nameLogo, NAMELOGO_HEIGHT_PX)"
            class="block object-contain pointer-events-none"
            decoding="async"
            fetchpriority="high" />
        </div>
      </ng-container>
      <ng-template #squareLogo>
        <div class="flex flex-row items-center">
          <ng-container *ngIf="normalLogo">
            <div style="width: auto;">
              <img
                [src]="normalLogo | assetPreview:'small':'webp'"
                [alt]="normalLogo.customFields?.altText ? normalLogo.customFields?.altText : 'logo'"
                [style.height]="logoHeight"
                style="pointer-events: none;"
                class="w-auto" />
            </div>
          </ng-container>
          <div *ngIf="!nameLogo && displayName" class="flex items-center">
            <div *ngIf="name" class="store-name">
              <p class="mr-5 ml-10 text-center">{{ name }}</p>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
  </a>
</div>
